import { useStrings } from "@1js/localization-components";
import { Tab, Text } from "@fluentui/react-components";
import React, { forwardRef } from "react";
import type { Appearance } from "../data";
import { YourPromptsLabel } from "./PromptTab.strings";
import { PromptTabs } from "./PromptTabs";
import { useStyles } from "./Tab.styles";

export const BookmarkedTabTestId = "bookmarked-prompts-tab";

type BookmarkTabProps = {
  isSelected: boolean;
  appearance: Appearance;
};

export const BookmarkTab = forwardRef<HTMLButtonElement, BookmarkTabProps>(
  ({ isSelected, appearance, ...props }, ref) => {
    const localizations = useStrings({
      YourPromptsLabel,
    });

    const classes = useStyles(appearance)();

    return (
      <Tab
        aria-label={localizations.YourPromptsLabel()}
        value={PromptTabs.SavedPrompts}
        data-testid={BookmarkedTabTestId}
        className={isSelected ? classes.selected : classes.tab}
        ref={ref}
        {...props}
      >
        <Text className={isSelected ? classes.selectedText : classes.text}>
          {localizations.YourPromptsLabel()}
        </Text>
      </Tab>
    );
  }
);

BookmarkTab.displayName = "BookmarkTab";
